import { render } from "./QuestionPage.vue?vue&type=template&id=02f75f26&scoped=true"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"

import "./QuestionPage.vue?vue&type=style&index=0&id=02f75f26&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f75f26"]])

export default __exports__